var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStickyNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5417 11.4583V32.0833H32.0833V43.5417H11.4583V11.4583H43.5417ZM43.5417 6.875H11.4583C8.9375 6.875 6.875 8.9375 6.875 11.4583V43.5417C6.875 46.0625 8.9375 48.125 11.4583 48.125H34.375L48.125 34.375V11.4583C48.125 8.9375 46.0625 6.875 43.5417 6.875ZM27.5 32.0833H16.0417V27.5H27.5V32.0833ZM38.9583 22.9167H16.0417V18.3333H38.9583V22.9167Z",
    fill: "#626161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNote);
export default __webpack_public_path__ + "static/media/sticky_note.1362e644dfd79b4e1193232de13c4e06.svg";
export { ForwardRef as ReactComponent };